/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type CoreMarket = (typeof CoreMarket)[keyof typeof CoreMarket];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoreMarket = {
  CH: "CH",
  DE: "DE",
  EU: "EU",
  US: "US",
  GLOBAL: "GLOBAL",
} as const;
